import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import FluidImage from 'components/FluidImage';
import VideoPlayer from 'components/VideoPlayer';
import OnPageEditing from 'components/OnPageEditing';

import { track } from 'tracking';

import css from './VideoListBlock.module.scss';

class VideoListBlock extends React.Component {
    static propTypes = {
        header: PropTypes.string,
        intro: PropTypes.string,
        size: PropTypes.oneOf([
            'large', 'small'
        ]).isRequired,
        blockId: PropTypes.number.isRequired,
        contentType: PropTypes.string,
        videos: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            subtitle: PropTypes.string,
            description: PropTypes.string,
            youtubeVideoId: PropTypes.string,
            previewImage: PropTypes.string,
            previewImageMobile: PropTypes.string,
        })).isRequired,
        squaredThumbnails: PropTypes.bool.isRequired,
        playVideoLabel: PropTypes.string.isRequired,
        isFullHeight:PropTypes.bool
    }

    static defaultProps = {
        size: 'large',
        squaredThumbnails: false,
    }

    state = {
        selected: 0,
        playing: false,
    }

    _handlePlayClick = () => {
        const video = this.props.videos[this.state.selected];

        // GA tracking
        track('youTubeTrack', {
            videoAction: 'play',
            videoUrl: 'http://youtube.com/watch?v='+video.youtubeVideoId,
            videoTitle: video.title,
        });

        this.setState({ playing: true });
    }

    _handleClick = e => {
        const selected = parseInt(e.currentTarget.dataset.video);
        const video = this.props.videos[selected];

        // GA tracking
        track('video_selection', `${video.title} - ${video.subtitle || ""}`);

        this.setState({
            playing: false,
            selected,
        });
    }

    render() {
        const {
            header,
            intro,
            size,
            blockId,
            contentType,
            videos,
            squaredThumbnails,
            playVideoLabel,
            isFullHeight
        } = this.props;

        const {
            selected,
            playing,
        } = this.state;

        const activeVideo = videos[selected];
        return (
            <div
                className={cn(css.block, {
                    [css.playing]: playing,
                    [css.condensed]: size === 'small',
                })}
                data-block={blockId}
                data-block-type="VideoListBlock"
            >
                {(header || intro) &&
                <header className={css.header}>
                    <OnPageEditing property="Header">
                        {header && <h2 className={css['block-heading']}>{header}</h2>}
                    </OnPageEditing>
                    <OnPageEditing property="Intro">
                        {intro && (
                            <p className={css['block-intro']}>
                                {intro}
                            </p>
                        )}
                    </OnPageEditing>
                </header>
                }
                {activeVideo && (
                    <VideoPlayer
                        {...activeVideo}
                        playing={playing}
                        onPageEditing={contentType !== 'VideoListBlock'}
                        onPlay={this._handlePlayClick}
                        playVideoLabel={playVideoLabel}
                        theme={isFullHeight ? VideoPlayer.themes.full: undefined}
                    />
                )}
                {videos.length > 1 && (
                    <OnPageEditing property="VideoList">
                        <ul className={css.videos}>
                            {videos.map((v,i) => (
                                <li key={i} className={css.video}>
                                    <button
                                        className={cn({
                                            [css.active]: i === selected
                                        })}
                                        data-video={i}
                                        onClick={this._handleClick}
                                    >
                                        <FluidImage
                                            className={cn(css.preview, {
                                                [css.squared]: squaredThumbnails
                                            })}
                                            image={v.previewImage}
                                        />
                                        <p className={css.subtitle}>{v.subtitle}</p>
                                        <p className={css.description}>{v.description}</p>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </OnPageEditing>
                )}
            </div>
        );
    }
}

export default VideoListBlock;



// WEBPACK FOOTER //
// ./src/components/VideoListBlock/VideoListBlock.jsx